import React, { useEffect, useState, useRef } from 'react';
import './ScrollToTopButton.css';
import rocketIcon from '../../assets/icons/rocket.svg';
import { Typography } from 'antd';
import { useAppSelector } from '../../hooks/useTypedSelector';

const { Text } = Typography;
const ScrollToTopButton: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [flying, setFlying] = useState(false);
  const btnRef = useRef<HTMLButtonElement | null>(null);
  const [inFooter, setInFooter] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const compareCollegeList = useAppSelector((state: any) => state.compare.compareCollege);
  const compareCourseList = useAppSelector((state: any) => state.compare.compareCourse);
  const compareListExists = ((window.location.pathname === "/college" || window.location.pathname === "/recommend-college-dream" || window.location.pathname === "/recommend-college-target" || window.location.pathname === "/recommend-college-safe" || window.location.pathname === "/mylist-college") && compareCollegeList && compareCollegeList.length > 0)
    || ((window.location.pathname === "/course" || window.location.pathname === "/recommend-course" || window.location.pathname === "/mylist-course") && compareCourseList && compareCourseList.length > 0);


  useEffect(() => {
    const checkModalOpen = () => {
      const modalElement = document.querySelector('.ant-modal-wrap');
      setIsModalOpen(!!modalElement);
    };

    checkModalOpen();

    const observer = new MutationObserver(checkModalOpen);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const footer = document.querySelector(".footer");
    if (!footer) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          setInFooter(entry.isIntersecting);
        });
      },
      { threshold: 0.06 }
    );

    observer.observe(footer);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.pageYOffset > 300 && !flying && !isModalOpen);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [flying, isModalOpen]);

  const handleClick = () => {
    if (flying) return;
    setFlying(true);

    try {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }

    setTimeout(() => setFlying(false), 1000);
  };

  useEffect(() => {
    const el = btnRef.current;
    if (!el) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleClick();
      }
    };
    el.addEventListener('keydown', onKey as any);
    return () => el.removeEventListener('keydown', onKey as any);
    //eslint-disable-next-line react-hooks/exhaustive-deps      
  }, [btnRef.current, flying]);

  return (
    <div className="scrollToTopButtonContainer">
    <button
      ref={btnRef}
      className={`scroll-to-top-button 
        ${visible ? 'visible' : ''} 
        ${flying ? 'flying' : ''} 
        ${inFooter ? 'footer-mode' : ''}`}
      onClick={handleClick}
      aria-label="Scroll to top"
      title="Back to top"
      type="button"
      style={{
        bottom: compareListExists ? "100px" : "",
        pointerEvents: visible ? 'auto' : 'none',
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.3s',
      }}
    >
      <span className="rocket-wrap">
        <img src={rocketIcon} alt="Rocket" className="rocket-img" />
        <span className="rocket-flame" aria-hidden="true"></span>
      </span>
      <Text>Top</Text>
    </button>
    </div>
  );
};

export default ScrollToTopButton;